import { twMerge } from "tailwind-merge"
export const bodyDefaultLightStyles = "text-[1rem] md:text-[1.125rem] font-medium leading-1.5"
const BodyDefaultLight: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, ...props }) => {
  return <p className={twMerge(bodyDefaultLightStyles, "mb-[1.25rem] md:mb-[1.5rem]", className)} {...props} />
}

export default BodyDefaultLight
